/* istanbul ignore file */
import { FunctionComponent, useEffect, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { Divider, Grid, Button } from '@material-ui/core';
import { get, isEmpty, isNil } from 'lodash';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { translate } from 'containers/services/translate';
import Inboxe from 'containers/CourtManagerLegalProceedings/ImagineDocuments/inboxe';
import { BinDiv } from 'containers/AppContainer/AppBar/style';
import {
  DrawerDiv,
  DrawerContainer,
  StyledContainerCard,
} from 'containers/CourtManagerLegalProceedings/ImagineDocuments/style';
import DocumentCard from 'containers/CourtManagerLegalProceedings/ImagineDocuments/document';
import {
  extractImagineDocumentByInboxes,
  extractOtherImagineDocument,
  getDocTypeID,
} from 'containers/CourtManagerLegalProceedings/ImagineDocuments/utils';
import DecisionDocumentDialog from 'containers/CourtManagerLegalProceedings/ImagineDocuments/DecisionDialog';
import { INBOXES_TYPES } from 'containers/AttributionManager/constants';
import { StyledPrimaryButton } from 'containers/CourtManagerLegalProceedings/ImagineDocuments/style';
import DropZoneFile from 'containers/CourtManagerLegalProceedings/ImagineDocuments/DropZoneFile';
import AddIcon from 'images/add-icon.svg';

export interface ImagineDocumentsDrawerProps {
  intl: IntlShape;
  isDrawerOpen: boolean;
  setIsDrawerOpen: Function;
  listings: any;
  expandRow: any;
  setExpandRow: any;
  claimSagisInfo: any;
  managerNotifcationsInboxes: any;
  claimId: number;
  requestMakeDecisionsDocumentImaging: Function;
  requestGetNotificationsInboxes: Function;
  isConsultation: boolean;
  imagineNotification: any;
  claimNumber?: any;
  shouldDisplayUploadDocument: boolean;
  requestUploadDocumentManager?: Function;
  requestGetDocByDocumentumId: Function;
}
const ImagineDocumentsDrawer: FunctionComponent<ImagineDocumentsDrawerProps> = ({
  ...props
}): JSX.Element => {
  const [selectedInboxeId, setSelectedInboxeId] = useState(null);
  const [OpenUploadFileArea, setOpenUploadFileArea] = useState(false);
  const [selectedInboxeOther, setSelectedInboxeOther] = useState(null);
  const [decisionOption, setDecisionOption] = useState(null);
  const [openDecisionDialog, setOpenDecisionDialog] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [imagineDocuments, setImagineDocuments] = useState([]);

  useEffect(() => {
    if (
      !isNil(
        get(
          props.imagineNotification,
          'managerNotificationType.managerInboxesId',
          null,
        ),
      )
    ) {
      setSelectedInboxeId(
        get(
          props.imagineNotification,
          'managerNotificationType.managerInboxesId',
          null,
        ),
      );
    }
    setImagineDocuments(
      extractImagineDocumentByInboxes(
        props.claimSagisInfo,
        props.managerNotifcationsInboxes,
        selectedInboxeId,
        props.listings,
      ),
    );
  }, [
    props.imagineNotification,
    props.claimSagisInfo,
    props.managerNotifcationsInboxes,
    selectedInboxeId,
  ]);

  const handleToggleDrawer = () => {
    props.setIsDrawerOpen(!props.isDrawerOpen);
    setSelectedInboxeId(null);
    setSelectedInboxeOther(null);
  };

  const handleClickOther = (payload: any) => {
    setSelectedInboxeOther(payload);
    setSelectedInboxeId(null);
  };

  const handleClickInboxes = (payload: any) => {
    setSelectedInboxeId(payload);
    setSelectedInboxeOther(null);
  };

  const handleCloseDecisionDialog = () => {
    setOpenDecisionDialog(false);
  };
  const handleDisplayUploadFileArea = () => {
    setOpenUploadFileArea(!OpenUploadFileArea);
  };
  const DocumentNotificationImagine = !isEmpty(props.imagineNotification)
    ? props.managerNotifcationsInboxes
        .filter(
          (el: any) =>
            !isEmpty(el.documentImaging) &&
            String(el.documentImaging.documentImagingId) ===
              String(
                get(
                  props.imagineNotification,
                  'documentImaging.documentImagingId',
                ),
              ),
        )
        .map((item: any) => item.documentImaging.documentImagingId)
    : !isEmpty(
        props.managerNotifcationsInboxes.filter(
          (el: any) =>
            !isEmpty(el.documentImaging) &&
            el.claimId === Number(props.claimId),
        ),
      )
    ? props.managerNotifcationsInboxes
        .filter(
          (el: any) =>
            !isEmpty(el.documentImaging) &&
            el.claimId === Number(props.claimId),
        )
        .map((item: any) => item.documentImaging.documentImagingId)
    : [];
  return (
    <DrawerContainer
      anchor="right"
      open={props.isDrawerOpen}
      onClose={handleToggleDrawer}
    >
      <DrawerDiv>
        <div className="titleConatainer">
          <span className="title">
            {translate({ ...messages.topCardDocTitle }, props)}
          </span>

          <ClearOutlinedIcon
            data-testid={'close-icon'}
            onClick={handleToggleDrawer}
          />
        </div>
        <Divider className="divider" />
        <div className="content">
          <Grid direction="row" container>
            <Grid item xs>
              <BinDiv>
                {get(props.listings, 'managerInboxes', [])
                  ?.filter(
                    (el: any) =>
                      el.type === INBOXES_TYPES.JUDICIARY ||
                      el.type === INBOXES_TYPES.OPENING,
                  )
                  ?.map(
                    (
                      element: {
                        title: string;
                        id: number;
                      },
                      index: number,
                    ) => (
                      <Inboxe
                        title={element.title}
                        managerInboxesId={get(element, 'id')}
                        setSelectedInboxeId={handleClickInboxes}
                        selectedInboxeId={selectedInboxeId as any}
                        isSelectedInboxe={
                          selectedInboxeId === get(element, 'id') &&
                          isNil(selectedInboxeOther)
                        }
                      />
                    ),
                  )}
                <Inboxe
                  title={translate({ ...messages.documentDrawerOther }, props)}
                  managerInboxesId={450}
                  setSelectedInboxeId={handleClickOther}
                  selectedInboxeId={selectedInboxeOther as any}
                  isSelectedInboxe={!isNil(selectedInboxeOther)}
                />
              </BinDiv>
            </Grid>
            {!isNil(selectedInboxeId) && isNil(selectedInboxeOther) && (
              <Grid item style={StyledContainerCard}>
                <Grid container direction="column" spacing={1}>
                  {imagineDocuments.map((el: any) => (
                    <Grid item>
                      <DocumentCard
                        document={el}
                        toTreat={DocumentNotificationImagine.includes(
                          el.DocumentID,
                        )}
                        decisionItems={get(
                          props.listings,
                          'documentImagingDecisions',
                          [],
                        )}
                        setDecisionOption={(payload: any) => {
                          setDecisionOption(payload);
                          setOpenDecisionDialog(true);
                          setSelectedDocument(el);
                        }}
                        decisionOption={decisionOption}
                        notificationDocument={props.managerNotifcationsInboxes
                          .filter(
                            (element: any) =>
                              !isEmpty(element.documentImaging) &&
                              element.claimId === Number(props.claimId),
                          )
                          .find(
                            (item: any) =>
                              item.documentImaging.documentImagingId ===
                              el.DocumentID,
                          )}
                        isConsultation={props.isConsultation}
                        requestGetDocByDocumentumId={
                          props.requestGetDocByDocumentumId
                        }
                      />
                    </Grid>
                  ))}
                </Grid>
                <Grid>
                  {!OpenUploadFileArea &&
                    !props.isConsultation &&
                    props.shouldDisplayUploadDocument &&
                    featureService.hasFeature(FEATURES.EVOLUTION_P1) &&
                    !isNil(getDocTypeID(props.listings, selectedInboxeId)) &&
                    get(props.listings, 'documentTypes', []).find(
                      (el: any) =>
                        String(el.ItemKey) ===
                        String(getDocTypeID(props.listings, selectedInboxeId)),
                    ) && (
                      <Button
                        style={{ ...(StyledPrimaryButton as any) }}
                        data-testId={'assign-button'}
                        onClick={handleDisplayUploadFileArea}
                      >
                        <Grid container direction="row" alignItems="center">
                          <Grid item>
                            <img
                              src={AddIcon}
                              style={{ marginTop: '4px' }}
                              alt="add icon"
                            />
                          </Grid>
                          <Grid item>
                            <span>{translate(messages.upload, props)}</span>
                          </Grid>
                        </Grid>
                      </Button>
                    )}

                  {OpenUploadFileArea && (
                    <DropZoneFile
                      requestUploadDocumentManager={
                        props.requestUploadDocumentManager
                      }
                      claimNumber={props.claimNumber}
                      docTypeId={getDocTypeID(props.listings, selectedInboxeId)}
                      docTypeName={get(
                        get(props.listings, 'documentTypes', []).find(
                          (el: any) =>
                            String(el.ItemKey) ===
                            String(
                              getDocTypeID(props.listings, selectedInboxeId),
                            ),
                        ),
                        'ItemDescription',
                        null,
                      )}
                      setOpenUploadFileArea={setOpenUploadFileArea}
                    />
                  )}
                </Grid>
              </Grid>
            )}

            {!isNil(selectedInboxeOther) && isNil(selectedInboxeId) && (
              <Grid item style={StyledContainerCard}>
                <Grid container direction="row" spacing={1}>
                  {extractOtherImagineDocument(
                    props.claimSagisInfo,
                    props.managerNotifcationsInboxes,
                    get(props.listings, 'managerNotificationType', []),
                    props.listings,
                  ).map((el: any) => (
                    <Grid item>
                      <DocumentCard
                        document={el}
                        toTreat={DocumentNotificationImagine.includes(
                          el.DocumentID,
                        )}
                        decisionItems={get(
                          props.listings,
                          'documentImagingDecisions',
                          [],
                        )}
                        setDecisionOption={(payload: any) => {
                          setDecisionOption(payload);
                          setOpenDecisionDialog(true);
                        }}
                        decisionOption={decisionOption}
                        notificationDocument={props.managerNotifcationsInboxes.find(
                          (el: any) =>
                            String(
                              get(el, 'documentImaging.documentImagingId'),
                            ) === String(el.DocumentID),
                        )}
                        isConsultation={props.isConsultation}
                        requestGetDocByDocumentumId={
                          props.requestGetDocByDocumentumId
                        }
                      />
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            )}
          </Grid>
          <DecisionDocumentDialog
            open={openDecisionDialog}
            onClose={handleCloseDecisionDialog}
            validateDialog={props.requestMakeDecisionsDocumentImaging}
            requestGetNotificationsInboxes={
              props.requestGetNotificationsInboxes
            }
            decisionOption={decisionOption}
            listings={props.listings}
            selectedDocument={selectedDocument}
            handleCloseDrawer={handleToggleDrawer}
            claimNumbers={props.claimNumber}
          />
        </div>
      </DrawerDiv>
    </DrawerContainer>
  );
};

export default injectIntl(ImagineDocumentsDrawer);
